// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditPopularLocationManagement-space1-cGvvS {
	margin-bottom: 6px !important;
}

.EditPopularLocationManagement-space2-g8o81 {
	margin-bottom: 12px !important;
}

.EditPopularLocationManagement-space3-MeCYz {
	margin-bottom: 18px !important;
}

.EditPopularLocationManagement-space4-hhaIQ {
	margin-bottom: 24px !important;
}

.EditPopularLocationManagement-space5-z78Tk {
	margin-bottom: 30px !important;
}

.EditPopularLocationManagement-space6-goVxS {
	margin-bottom: 36px !important;
}

.EditPopularLocationManagement-space7-yyeFb {
	margin-bottom: 42px !important;
}

.EditPopularLocationManagement-space8-n5H9y {
	margin-bottom: 48px !important;
}

.EditPopularLocationManagement-spaceTop1-v985h {
	margin-top: 6px !important;
}

.EditPopularLocationManagement-spaceTop2-tc4o4 {
	margin-top: 12px !important;
}

.EditPopularLocationManagement-spaceTop3-_aZ_9 {
	margin-top: 18px !important;
}

.EditPopularLocationManagement-spaceTop4-Pae1A {
	margin-top: 24px !important;
}

.EditPopularLocationManagement-spaceTop5-LLjkB {
	margin-top: 30px !important;
}

.EditPopularLocationManagement-spaceTop6-hErlk {
	margin-top: 36px !important;
}

.EditPopularLocationManagement-spaceTop7-cVW_B {
	margin-top: 42px !important;
}

.EditPopularLocationManagement-spaceTop8-VjPQc {
	margin-top: 48px !important;
}

.EditPopularLocationManagement-noMargin-r81KO {
	margin: 0px !important;
}

.EditPopularLocationManagement-padding1-aG2O4 {
	padding-bottom: 6px !important;
}

.EditPopularLocationManagement-padding2-o0VEp {
	padding-bottom: 12px !important;
}

.EditPopularLocationManagement-padding3-zDan8 {
	padding-bottom: 18px !important;
}

.EditPopularLocationManagement-padding4-Q2evC {
	padding-bottom: 24px !important;
}

.EditPopularLocationManagement-padding5-s4Qos {
	padding-bottom: 30px !important;
}

.EditPopularLocationManagement-padding6-Rkwv_ {
	padding-bottom: 36px !important;
}

.EditPopularLocationManagement-padding7-HNb7q {
	padding-bottom: 42px !important;
}

.EditPopularLocationManagement-paddingTop1-h4knI {
	padding-top: 6px !important;
}

.EditPopularLocationManagement-paddingTop2-mqsAo {
	padding-top: 12px !important;
}

.EditPopularLocationManagement-paddingTop3-_xl02 {
	padding-top: 18px !important;
}

.EditPopularLocationManagement-paddingTop4-EXSM3 {
	padding-top: 24px !important;
}

.EditPopularLocationManagement-paddingTop5-NL1so {
	padding-top: 30px !important;
}

.EditPopularLocationManagement-paddingTop6-sHimo {
	padding-top: 36px !important;
}

.EditPopularLocationManagement-paddingTop7-BPh_q {
	padding-top: 42px !important;
}

.EditPopularLocationManagement-noPadding-GSnUE {
	padding: 0px !important;
}

.EditPopularLocationManagement-spaceMarginBottom0-lYgs5 {
	margin-bottom: 0;
}

.EditPopularLocationManagement-textBold-AxBYy {
	font-weight: 500 !important;
}

.EditPopularLocationManagement-textBolder-NbFCt {
	font-weight: 700 !important;
}

.EditPopularLocationManagement-textNormal-CH0i8 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.EditPopularLocationManagement-textDarkBlue-roEL3 {
	color: rgb(20, 39, 94) !important;
}

.EditPopularLocationManagement-textLightBlue-wiypR {
	color: rgb(57, 87, 106) !important;
}

.EditPopularLocationManagement-textLightSandleGreen-nFU5e {
	color: rgb(76, 86, 41) !important;
}

.EditPopularLocationManagement-textLightBrown-ixrpu {
	color: rgb(115, 79, 33) !important;
}

.EditPopularLocationManagement-textMediumMaroon-joj90 {
	color: rgb(87, 37, 51) !important;
}

.EditPopularLocationManagement-textBrown-CPnju {
	color: rgb(160, 47, 24) !important;
}

.EditPopularLocationManagement-textMaroon-FiMJT {
	color: rgb(155, 49, 67) !important;
}

.EditPopularLocationManagement-textDarkBrown-mL837 {
	color: rgb(83, 18, 16) !important;
}

.EditPopularLocationManagement-textMediumBrown-YBFmL {
	color: rgb(142, 28, 10) !important;
}

.EditPopularLocationManagement-textSkyBlue-bE57B {
	color: rgb(37, 117, 141) !important;
}

.EditPopularLocationManagement-textGray-v2kHL {
	color: rgb(77, 65, 51) !important;
}

.EditPopularLocationManagement-errorMessage-_0fOn {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.EditPopularLocationManagement-userText-xJ8hr {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.EditPopularLocationManagement-panelHeader-tBTwD {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.EditPopularLocationManagement-exportSection-XOeLF {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.EditPopularLocationManagement-exportSectionGridSub-g0Cab {
	grid-template-columns: 50% 49% !important;
}

.EditPopularLocationManagement-exportText-FRi71 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.EditPopularLocationManagement-exportLinkImg-uubjH {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.EditPopularLocationManagement-exportImg-oOamk {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditPopularLocationManagement-linkBtn-MTeeO {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.EditPopularLocationManagement-table-ML2pS {
	display: table;
}

.EditPopularLocationManagement-tableRow-d2hK7 {
	display: table-row;
}

.EditPopularLocationManagement-tableCell-ZyG4E {
	display: table-cell;
	float: none;
}

.EditPopularLocationManagement-formGroup-uP1SJ {
	margin-bottom: 6px;
}

.EditPopularLocationManagement-marginTop0-NTHmW {
	margin-top: 0;
}

.EditPopularLocationManagement-marginBottom20-Y5T9f {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.EditPopularLocationManagement-bannerImageBg-qBW7_ {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.EditPopularLocationManagement-bannerDelete-MyKmh {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.EditPopularLocationManagement-exportLink-LeH67 {
	padding-top: 10px;
	padding-right: 10px;
}

.EditPopularLocationManagement-seachContent-sFrjV {
	padding-left: 0px;
	margin-bottom: 5px;
}

.EditPopularLocationManagement-marginBottom9-CNADe {
	margin-bottom: 9px;
}

.EditPopularLocationManagement-spaceTop52-icLxG {
	margin-top: 52px;
}

.EditPopularLocationManagement-profileViewInner-yym0O {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.EditPopularLocationManagement-profileViewMain-XMZc6 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.EditPopularLocationManagement-profileViewlabel-IongH {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.EditPopularLocationManagement-profileViewMainContent-sMKX1 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.EditPopularLocationManagement-reviewsFormStar-R4_5W {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.EditPopularLocationManagement-reviewsFormStar-R4_5W svg {
	cursor: pointer;
}

.EditPopularLocationManagement-addLanguageText-zLj4w {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.EditPopularLocationManagement-exportSection-XOeLF {
		grid-template-columns: 100%;
	}

	.EditPopularLocationManagement-spaceTop52-icLxG {
		margin-top: 18px;
	}

	.EditPopularLocationManagement-exportText-FRi71 {
		float: none;
		margin-top: 12px;
	}

	.EditPopularLocationManagement-exportSectionGridSub-g0Cab {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.EditPopularLocationManagement-profileViewlabel-IongH {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditPopularLocationManagement-profileViewMainContent-sMKX1 {
		width: 100%;
		text-align: center;
	}

	.EditPopularLocationManagement-panelHeader-tBTwD {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.EditPopularLocationManagement-popularLocationDivider-kcbes {
    padding-bottom: 18px;
    border-bottom: 1px solid var(--primary-border);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/EditPopularLocation/EditPopularLocationManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,oBAAoB;IACpB,8CAA8C;AAClD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.popularLocationDivider {\n    padding-bottom: 18px;\n    border-bottom: 1px solid var(--primary-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditPopularLocationManagement-space1-cGvvS`,
	"space2": `EditPopularLocationManagement-space2-g8o81`,
	"space3": `EditPopularLocationManagement-space3-MeCYz`,
	"space4": `EditPopularLocationManagement-space4-hhaIQ`,
	"space5": `EditPopularLocationManagement-space5-z78Tk`,
	"space6": `EditPopularLocationManagement-space6-goVxS`,
	"space7": `EditPopularLocationManagement-space7-yyeFb`,
	"space8": `EditPopularLocationManagement-space8-n5H9y`,
	"spaceTop1": `EditPopularLocationManagement-spaceTop1-v985h`,
	"spaceTop2": `EditPopularLocationManagement-spaceTop2-tc4o4`,
	"spaceTop3": `EditPopularLocationManagement-spaceTop3-_aZ_9`,
	"spaceTop4": `EditPopularLocationManagement-spaceTop4-Pae1A`,
	"spaceTop5": `EditPopularLocationManagement-spaceTop5-LLjkB`,
	"spaceTop6": `EditPopularLocationManagement-spaceTop6-hErlk`,
	"spaceTop7": `EditPopularLocationManagement-spaceTop7-cVW_B`,
	"spaceTop8": `EditPopularLocationManagement-spaceTop8-VjPQc`,
	"noMargin": `EditPopularLocationManagement-noMargin-r81KO`,
	"padding1": `EditPopularLocationManagement-padding1-aG2O4`,
	"padding2": `EditPopularLocationManagement-padding2-o0VEp`,
	"padding3": `EditPopularLocationManagement-padding3-zDan8`,
	"padding4": `EditPopularLocationManagement-padding4-Q2evC`,
	"padding5": `EditPopularLocationManagement-padding5-s4Qos`,
	"padding6": `EditPopularLocationManagement-padding6-Rkwv_`,
	"padding7": `EditPopularLocationManagement-padding7-HNb7q`,
	"paddingTop1": `EditPopularLocationManagement-paddingTop1-h4knI`,
	"paddingTop2": `EditPopularLocationManagement-paddingTop2-mqsAo`,
	"paddingTop3": `EditPopularLocationManagement-paddingTop3-_xl02`,
	"paddingTop4": `EditPopularLocationManagement-paddingTop4-EXSM3`,
	"paddingTop5": `EditPopularLocationManagement-paddingTop5-NL1so`,
	"paddingTop6": `EditPopularLocationManagement-paddingTop6-sHimo`,
	"paddingTop7": `EditPopularLocationManagement-paddingTop7-BPh_q`,
	"noPadding": `EditPopularLocationManagement-noPadding-GSnUE`,
	"spaceMarginBottom0": `EditPopularLocationManagement-spaceMarginBottom0-lYgs5`,
	"textBold": `EditPopularLocationManagement-textBold-AxBYy`,
	"textBolder": `EditPopularLocationManagement-textBolder-NbFCt`,
	"textNormal": `EditPopularLocationManagement-textNormal-CH0i8`,
	"textDarkBlue": `EditPopularLocationManagement-textDarkBlue-roEL3`,
	"textLightBlue": `EditPopularLocationManagement-textLightBlue-wiypR`,
	"textLightSandleGreen": `EditPopularLocationManagement-textLightSandleGreen-nFU5e`,
	"textLightBrown": `EditPopularLocationManagement-textLightBrown-ixrpu`,
	"textMediumMaroon": `EditPopularLocationManagement-textMediumMaroon-joj90`,
	"textBrown": `EditPopularLocationManagement-textBrown-CPnju`,
	"textMaroon": `EditPopularLocationManagement-textMaroon-FiMJT`,
	"textDarkBrown": `EditPopularLocationManagement-textDarkBrown-mL837`,
	"textMediumBrown": `EditPopularLocationManagement-textMediumBrown-YBFmL`,
	"textSkyBlue": `EditPopularLocationManagement-textSkyBlue-bE57B`,
	"textGray": `EditPopularLocationManagement-textGray-v2kHL`,
	"errorMessage": `EditPopularLocationManagement-errorMessage-_0fOn`,
	"userText": `EditPopularLocationManagement-userText-xJ8hr`,
	"panelHeader": `EditPopularLocationManagement-panelHeader-tBTwD`,
	"exportSection": `EditPopularLocationManagement-exportSection-XOeLF`,
	"exportSectionGridSub": `EditPopularLocationManagement-exportSectionGridSub-g0Cab`,
	"exportText": `EditPopularLocationManagement-exportText-FRi71`,
	"exportLinkImg": `EditPopularLocationManagement-exportLinkImg-uubjH`,
	"exportImg": `EditPopularLocationManagement-exportImg-oOamk`,
	"linkBtn": `EditPopularLocationManagement-linkBtn-MTeeO`,
	"table": `EditPopularLocationManagement-table-ML2pS`,
	"tableRow": `EditPopularLocationManagement-tableRow-d2hK7`,
	"tableCell": `EditPopularLocationManagement-tableCell-ZyG4E`,
	"formGroup": `EditPopularLocationManagement-formGroup-uP1SJ`,
	"marginTop0": `EditPopularLocationManagement-marginTop0-NTHmW`,
	"marginBottom20": `EditPopularLocationManagement-marginBottom20-Y5T9f`,
	"bannerImageBg": `EditPopularLocationManagement-bannerImageBg-qBW7_`,
	"bannerDelete": `EditPopularLocationManagement-bannerDelete-MyKmh`,
	"exportLink": `EditPopularLocationManagement-exportLink-LeH67`,
	"seachContent": `EditPopularLocationManagement-seachContent-sFrjV`,
	"marginBottom9": `EditPopularLocationManagement-marginBottom9-CNADe`,
	"spaceTop52": `EditPopularLocationManagement-spaceTop52-icLxG`,
	"profileViewInner": `EditPopularLocationManagement-profileViewInner-yym0O`,
	"profileViewMain": `EditPopularLocationManagement-profileViewMain-XMZc6`,
	"profileViewlabel": `EditPopularLocationManagement-profileViewlabel-IongH`,
	"profileViewMainContent": `EditPopularLocationManagement-profileViewMainContent-sMKX1`,
	"reviewsFormStar": `EditPopularLocationManagement-reviewsFormStar-R4_5W`,
	"addLanguageText": `EditPopularLocationManagement-addLanguageText-zLj4w`,
	"popularLocationDivider": `EditPopularLocationManagement-popularLocationDivider-kcbes`
};
module.exports = ___CSS_LOADER_EXPORT___;
